import { PublicClientApplication } from '@azure/msal-browser';
import msalConfig from './msal-config';

/** Shared MSAL PCA — used by AppShell and admin API helpers. */
export const msalInstance = new PublicClientApplication(msalConfig);

export const msalInitializedPromise = msalInstance.initialize();
